module.exports = __webpack_public_path__ + "static/media/ammo_showcase.c0b55a15.webp";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/ammo_showcase.webp
// module id = 250
// module chunks = 0